import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/table";
import { applyMask } from "shared/utils/masks";
import {
  ContractualRentCategory,
  ContractualRentCompany,
} from "./contractualRent.types";

interface ContractualRentCompanyTableProps {
  companies: ContractualRentCompany[];
  categories: ContractualRentCategory[];
}

/** Per-company split; one column per category that has any amount. */
export const ContractualRentCompanyTable = ({
  companies,
  categories,
}: ContractualRentCompanyTableProps) => {
  const columns = categories.filter((category) => category.amount !== 0);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Vennootschap</TableHead>
          <TableHead className="text-right">Contr.</TableHead>
          {columns.map((category) => (
            <TableHead key={category.key} className="text-right">
              {category.label}
            </TableHead>
          ))}
          <TableHead className="text-right">Totaal</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {companies.map((company) => (
          <TableRow key={company.companyId ?? "none"}>
            <TableCell className="max-w-[160px] truncate" title={company.companyName}>
              {company.companyName}
            </TableCell>
            <TableCell className="text-right tabular-nums">
              {company.contractCount}
            </TableCell>
            {columns.map((category) => (
              <TableCell key={category.key} className="text-right tabular-nums">
                {applyMask(company.amounts[category.key], "valuta")}
              </TableCell>
            ))}
            <TableCell className="text-right font-semibold tabular-nums">
              {applyMask(company.total, "valuta")}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
